import { render, staticRenderFns } from "./GitSha.vue?vue&type=template&id=2c38da16"
import script from "./GitSha.vue?vue&type=script&lang=js"
export * from "./GitSha.vue?vue&type=script&lang=js"
import style0 from "./GitSha.vue?vue&type=style&index=0&id=2c38da16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports